import axios from "axios";
import config from "../config.js";

/**
 * Password API - Public endpoint for one-time secrets
 * No authentication required
 */
class PasswordApi {
  private baseURL: string;

  constructor() {
    this.baseURL = config.apiUrl || "";
  }

  /**
   * Get one-time secret by key
   * This is a public endpoint, no authentication required
   */
  public getSecret = async (key: string) => {
    try {
      const response = await axios.get(`${this.baseURL}/password?key=${encodeURIComponent(key)}`, {
        timeout: 10000,
      });
      return response.data;
    } catch (error: any) {
      // Return error response data if available
      if (error.response?.data) {
        throw error.response.data;
      }
      throw error;
    }
  };

  /**
   * Mark secret as viewed after user has seen it
   * This is a public endpoint, no authentication required
   */
  public markAsViewed = async (key: string) => {
    try {
      const response = await axios.post(
        `${this.baseURL}/password/mark-viewed`,
        { key },
        {
          timeout: 10000,
        }
      );
      return response.data;
    } catch (error: any) {
      // Return error response data if available
      if (error.response?.data) {
        throw error.response.data;
      }
      throw error;
    }
  };
}

export default new PasswordApi();
